import { isDefaultPlaceholderUrl } from './isDefaultPlaceholderUrl';

/** True for a template-default header photo: a known placeholder URL, or one tagged `isDefault=true`. */
export const isAnyDefaultPhotoUrl = (url: string): boolean => {
  if (isDefaultPlaceholderUrl(url)) return true;
  try {
    return new URL(url).searchParams.get('isDefault') === 'true';
  } catch {
    return false;
  }
};
